import Icon from 'components/shared/Icon/Icon';

const BulletItem = ({ children, color }) => (
  <li className="flex items-start gap-2">
    <div className="flex h-5 items-center">
      <Icon icon="colored-dot-indicators" size={12} color={color ?? 'purple'} />
    </div>
    <p className="text-sm text-neutral-800">{children}</p>
  </li>
);

export default BulletItem;
